const i = (a) => {
  const e = /* @__PURE__ */ new Set();
  return a && ["path", "query", "headers", "cookies"].some((n) => {
    var s, t;
    return (t = (s = a.parameters) == null ? void 0 : s[n]) == null ? void 0 : t.some((r) => {
      r.required && r.value === "" && e.add(r.key);
    });
  }), e;
};
export {
  i as validateParameters
};
